import { Typography } from "antd";
import styled, { css } from "styled-components";

export const PrimaryText = styled(Typography.Text)<{
    fontSize?: number;
    fontWeight?: string;
    lineHeight?: string;
    textAlign?: string;
    padding?: string;
    margin?: string;
    $textNoWrap?: boolean;
    $textColor?:
        | "accent"
        | "error"
        | "disabled"
        | "white"
        | "success"
        | "warning";
    $inline?: boolean;
}>`
    display: ${({ $inline = false }) => ($inline ? "inline" : "block")};
    padding: ${({ padding }) => padding || "0"};
    margin: ${({ margin }) => margin || "0"};
    font-size: ${({ fontSize }) => `${fontSize || 14}px`};
    font-weight: ${({ fontWeight }) => fontWeight};
    line-height: ${({ lineHeight }) => lineHeight || "20px"};
    text-align: ${({ textAlign }) => textAlign || "left"};
    text-wrap: ${({ $textNoWrap }) => ($textNoWrap ? "nowrap" : "wrap")};
    && {
        ${({ theme, $textColor }) => {
            let color = theme.primaryTypographyColor;

            switch ($textColor) {
                case "accent":
                    color = theme.additionalTypographyColor;
                    break;
                case "error":
                    color = theme.dangerTypographyColor;
                    break;
                case "success":
                    color = theme.successTypographyColor;
                    break;
                case "disabled":
                    color = theme.disabledTypographyColor;
                    break;
                case "white":
                    color = theme.colors.white;
                    break;
                case "warning":
                    color = theme.colors.warning;
                    break;
                default:
                    color = theme.primaryTypographyColor;
                    break;
            }

            return css`
                color: ${color};
            `;
        }}
    }
`;

export const SecondaryText = styled(Typography.Text)<{
    fontSize?: number;
    fontWeight?: string;
    lightTheme?: boolean;
    lineHeight?: string;
    textAlign?: string;
    padding?: string;
    margin?: string;
    $textNoWrap?: boolean;
}>`
    display: block;
    padding: ${({ padding }) => padding || "0"};
    margin: ${({ margin }) => margin || "0"};
    font-size: ${({ fontSize }) => fontSize}px;
    font-weight: ${({ fontWeight }) => fontWeight};
    line-height: ${({ lineHeight }) => lineHeight || "20px"};
    text-align: ${({ textAlign }) => textAlign || "left"};
    text-wrap: ${({ $textNoWrap }) => ($textNoWrap ? "nowrap" : "wrap")};
    && {
        color: ${(props) => props.theme.secondaryTypographyColor};
        ${(props) => props?.lightTheme && `color: #ffffff;`};
    }
`;
